export const footer = {
  time: "с 9:00 до 21:00 (без выходных)",
  phone: "+7 747 557 74 64",
  address_city: "Казахстан, Алматы",
  address: "улица Желтоксан 168а",
  faqs: "FAQs",
  list: "оборудование списком",
};
